module.exports = __webpack_public_path__ + "img/logo.4268438a.png";